import GeneralActionTypes from './general.types';

const INITIAL_STATE: any = {
	isDetailsEdit: false,
	isOffcanvasOpen: false,

	activeTab: 'BasicDetails',
	sideTabValue: 'MemberDetailsPage',

	fatherContactVerify: '',
	motherContactVerify: '',
	ref1ContactVerify: '',
	ref2ContactVerify: '',
	fatherNumberReview: '',
	motherNumberReview: '',
	ref1NumberReview: '',
	ref2NumberReview: '',

	aadharNumberVerify: '',
	aadharNameVerify: '',
	aadharFatherNameVerify: '',
	aadharDobVerify: '',
	aadharCityVerify: '',
	aadharStateVerify: '',
	aadharPinCodeVerify: '',
	aadharAddressVerify: '',
	aadharFrontImageVerify: '',
	aadharBackImageVerify: '',

	employeeIdFrontImageVerify: '',
	employeeIdBackImageVerify: '',
	employeeIdNumberVerify: '',
	employeeIdNameVerify: '',
	employeeDesignationVerify: '',
	employeeDojVerify: '',
	nameOrganizationVerify: '',
	yearOrganizationVerify: '',
	locationVerify: '',

	dlFrontImageVerify: '',
	dlBackImageVerify: '',
	dlNumberVerify: '',
	dlExpiryDateVerify: '',

	voterIdFrontImageVerify: '',
	voterIdBackImageVerify: '',

	passportFrontImageVerify: '',
	passportBackImageVerify: '',
	passportNumberVerify: '',
	passportDateIssueVerify: '',
	passportExpiryDateVerify: '',

	selfieImageVerify: '',
	selfieVideoVerify: '',

	collegeNameVerify: '',
	streamVerify: '',
	selectFromyearVerify: '',
	selectToyearVerify: '',
	courseShortFormVerify: '',
	programCategaryVerify: '',
	rollNumberVerify: '',
	collegeIdFrontImageVerify: '',
	collegeIdBackImageVerify: '',
	marksheetOrFeesVerify: '',

	totalMonthlySalaryVerify: '',
	esinumberVerify: '',
	paysilpMonthVerify: '',
	pfDeductionVerify: '',
	payslipDocumentVerify: '',

	bankStatementVerify: '',

	pancardImageVerify: '',
	pancardNumberVerify: '',

	allMachedVerify: '',
	isPhoneCallVerify: '',

	basicDetailsVerify: 0,
	aadharDeatilsVerified: 0,
	collegeIdDetailsVerified: 0,
	employeeIdDetailsVerified: 0,
	payslipDetailsVerified: 0,
	pancardDetailsVerified: 0,
	drirvingLicenceDetailsVerified: 0,
	voterIdDetailsVerified: 0,
	passportDetailsVerified: 0,
	photoVideoDetailsVerified: 0,
	bankDetailDetailsVerified: 0,

	allDocumentMatchedReview: '',
	phoneCallReview: '',
	basicDetailsReview: '',
	aadharReview: '',
	panCardReview: '',
	collegeReview: '',
	employeeIdReview: '',
	paySlipReview: '',
	dirvingLicenceReview: '',
	passportReview: '',
	voterIDCardReview: '',
	photosAndVideoReview: '',
	bankDetailsReview: '',

	jobDetails: '',
};

const generalReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case GeneralActionTypes.IS_EDIT_DETAILS_START:
			return { ...state, isDetailsEdit: action.payload };

		case GeneralActionTypes.IS_OPEN_OFFCANVAS_START:
			return { ...state, isOffcanvasOpen: action.payload };

		case GeneralActionTypes.SIDE_TAB_VALUE_CHANGED:
			return { ...state, sideTabValue: action.payload };

		case GeneralActionTypes.DOCUMENT_TAB_BAR_FOR_TYPE_CHANGED:
			return { ...state, documentBarType: action.payload };

		case GeneralActionTypes.DOCUMENT_TAB_BAR_VALUE_CHANGED:
			return { ...state, documentTabBardValue: action.payload };

		case GeneralActionTypes.ACTIVE_TAB_CHANGED:
			return {
				...state,
				activeTab: action.payload,
			};
		case GeneralActionTypes.UPDATE_STATE_REDUCER_CHANGED:
			return action.payload;
		/** *************** BASIC DETAILS ******************* */
		case GeneralActionTypes.FATHER_CONTACT_VERIFY_CHANGED:
			return {
				...state,
				fatherContactVerify: action.payload,
			};

		case GeneralActionTypes.MOTHER_CONTACT_VERIFY_CHANGED:
			return {
				...state,
				motherContactVerify: action.payload,
			};

		case GeneralActionTypes.REFERENCE_ONE_CONTACT_VERIFY_CHANGED:
			return {
				...state,
				ref1ContactVerify: action.payload,
			};

		case GeneralActionTypes.REFERENCE_TWO_CONTACT_VERIFY_CHANGED:
			return {
				...state,
				ref2ContactVerify: action.payload,
			};

		case GeneralActionTypes.FATHER_PHONECALL_REVIEW_VERIFY_CHANGED:
			return {
				...state,
				fatherNumberReview: action.payload,
			};

		case GeneralActionTypes.MOTHER_PHONECALL_REVIEW_VERIFY_CHANGED:
			return {
				...state,
				motherNumberReview: action.payload,
			};

		case GeneralActionTypes.REF1_PHONECALL_REVIEW_VERIFY_CHANGED:
			return {
				...state,
				ref1NumberReview: action.payload,
			};

		case GeneralActionTypes.REF2_PHONECALL_REVIEW_VERIFY_CHANGED:
			return {
				...state,
				ref2NumberReview: action.payload,
			};
		/** *************** AADHAR VERIFY DETAILS ******************* */

		case GeneralActionTypes.AADHAR_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				aadharFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_BACK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				aadharBackImageVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				aadharNumberVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_NAME_VERIFY_CHANGED:
			return {
				...state,
				aadharNameVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_FATHER_NAME_VERIFY_CHANGED:
			return {
				...state,
				aadharFatherNameVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_DOB_VERIFY_CHANGED:
			return {
				...state,
				aadharDobVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_CITY_VERIFY_CHANGED:
			return {
				...state,
				aadharCityVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_STATE_VERIFY_CHANGED:
			return {
				...state,
				aadharStateVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_PINCODE_VERIFY_CHANGED:
			return {
				...state,
				aadharPinCodeVerify: action.payload,
			};

		case GeneralActionTypes.AADHAR_ADDRESS_VERIFY_CHANGED:
			return {
				...state,
				aadharAddressVerify: action.payload,
			};

		/** *************** EMPLOYEE VERIFY DETAILS ******************* */

		case GeneralActionTypes.EMPLOYEE_ID_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				employeeIdFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_ID_BAcK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				employeeIdBackImageVerify: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_ID_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				employeeIdNumberVerify: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_ID_NAME_VERIFY_CHANGED:
			return {
				...state,
				employeeIdNameVerify: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_DESIGNATION_VERIFY_CHANGED:
			return {
				...state,
				employeeDesignationVerify: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_ID_DOJ_CHANGED:
			return {
				...state,
				employeeDojVerify: action.payload,
			};

		case GeneralActionTypes.NAME_ORGANIZATION_VERIFY_CHANGED:
			return {
				...state,
				nameOrganizationVerify: action.payload,
			};

		case GeneralActionTypes.YEAR_ORGANIZATION_VERIFY_CHANGED:
			return {
				...state,
				yearOrganizationVerify: action.payload,
			};

		case GeneralActionTypes.LOCATION_VERIFY_CHANGED:
			return {
				...state,
				locationVerify: action.payload,
			};

		/** *************** DRIVING LICENCE DETAILS ******************* */

		case GeneralActionTypes.DL_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				dlFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.DL_BAcK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				dlBackImageVerify: action.payload,
			};

		case GeneralActionTypes.DL_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				dlNumberVerify: action.payload,
			};

		case GeneralActionTypes.DL_EXPIRY_DATE_VERIFY_CHANGED:
			return {
				...state,
				dlExpiryDateVerify: action.payload,
			};

		/** *************** DRIVING LICENCE DETAILS ******************* */

		case GeneralActionTypes.VOTER_ID_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				voterIdFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.VOTER_ID_BAcK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				voterIdBackImageVerify: action.payload,
			};

		/** *************** DRIVING LICENCE DETAILS ******************* */

		case GeneralActionTypes.PASSPORT_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				passportFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.PASSPORT_BAcK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				passportBackImageVerify: action.payload,
			};

		case GeneralActionTypes.PASSPORT_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				passportNumberVerify: action.payload,
			};

		case GeneralActionTypes.PASSPORT_DATE_ISSUE_VERIFY_CHANGED:
			return {
				...state,
				passportDateIssueVerify: action.payload,
			};

		case GeneralActionTypes.PASSPORT_EXPIRY_DATE_VERIFY_CHANGED:
			return {
				...state,
				passportExpiryDateVerify: action.payload,
			};

		/** *************** PHOTO AND VIDEOS ******************* */

		case GeneralActionTypes.SELFIE_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				selfieImageVerify: action.payload,
			};

		case GeneralActionTypes.SELFIE_VIEOS_VERIFY_CHANGED:
			return {
				...state,
				selfieVideoVerify: action.payload,
			};

		/** *************** EMPLOYEE VERIFY DETAILS ******************* */

		case GeneralActionTypes.COLLEGE_ID_FRONT_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				collegeIdFrontImageVerify: action.payload,
			};

		case GeneralActionTypes.COLLEGE_ID_BAcK_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				collegeIdBackImageVerify: action.payload,
			};

		case GeneralActionTypes.COLLEGE_NAME_VERIFY_CHANGED:
			return {
				...state,
				collegeNameVerify: action.payload,
			};

		case GeneralActionTypes.STREAM_VERIFY_CHANGED:
			return {
				...state,
				streamVerify: action.payload,
			};

		case GeneralActionTypes.SELECT_FROM_YEAR_VERIFY_CHANGED:
			return {
				...state,
				selectFromyearVerify: action.payload,
			};

		case GeneralActionTypes.SELECT_TO_YEAR_VERIFY_CHANGED:
			return {
				...state,
				selectToyearVerify: action.payload,
			};

		case GeneralActionTypes.COURSE_SHORT_FORM_VERIFY_CHANGED:
			return {
				...state,
				courseShortFormVerify: action.payload,
			};

		case GeneralActionTypes.PROGRAM_CATEGARY_VERIFY_CHANGED:
			return {
				...state,
				programCategaryVerify: action.payload,
			};

		case GeneralActionTypes.ROLL_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				rollNumberVerify: action.payload,
			};

		case GeneralActionTypes.MARK_SHEET_VERIFY_CHANGED:
			return {
				...state,
				marksheetOrFeesVerify: action.payload,
			};

		/** *************** PAYSILIP VERIFY DETAILS ******************* */

		case GeneralActionTypes.TOTAL_MONTHLY_SALARY_VERIFY_CHANGED:
			return {
				...state,
				totalMonthlySalaryVerify: action.payload,
			};

		case GeneralActionTypes.ESI_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				esinumberVerify: action.payload,
			};

		case GeneralActionTypes.PAYSLIP_MONTH_VERIFY_CHANGED:
			return {
				...state,
				paysilpMonthVerify: action.payload,
			};

		case GeneralActionTypes.PF_DEDUCTION_VERIFY_CHANGED:
			return {
				...state,
				pfDeductionVerify: action.payload,
			};

		case GeneralActionTypes.PAYSLIP_DOCUMENT_VERIFY_CHANGED:
			return {
				...state,
				payslipDocumentVerify: action.payload,
			};

		/** *************** PAYSILIP VERIFY DETAILS ******************* */

		case GeneralActionTypes.BANK_STATEMENT_VERIFY_CHANGED:
			return {
				...state,
				bankStatementVerify: action.payload,
			};

		/** *************** PANCARD DETAILS ******************* */

		case GeneralActionTypes.PANCARD_IMAGE_VERIFY_CHANGED:
			return {
				...state,
				pancardImageVerify: action.payload,
			};

		case GeneralActionTypes.PANCARD_NUMBER_VERIFY_CHANGED:
			return {
				...state,
				pancardNumberVerify: action.payload,
			};

		/** *************** PANCARD DETAILS ******************* */

		case GeneralActionTypes.ALL_MACHED_VERIFY_CHANGED:
			return {
				...state,
				allMachedVerify: action.payload,
			};

		case GeneralActionTypes.IS_PHONECALL_ATTEND_VERIFY_CHENGED:
			return {
				...state,
				isPhoneCallVerify: action.payload,
			};

		/** *************** ALL DETAILS VERIFY ******************* */
		case GeneralActionTypes.BASIC_DETAILS_VERIFY_CHANGED:
			return {
				...state,
				basicDetailsVerify: action.payload,
				basicDetailsReview: action.payload === 1 ? '' : state.basicDetailsReview,
			};

		case GeneralActionTypes.AADHAR_DETAILS_VERIFY_CHENGED:
			return {
				...state,
				aadharDeatilsVerified: action.payload,
				aadharReview: action.payload === 1 ? '' : state.aadharReview,
			};

		case GeneralActionTypes.COLLEGE_DETAILS_VERIFY_CHANGED:
			return {
				...state,
				collegeIdDetailsVerified: action.payload,
				collegeReview: action.payload === 1 ? '' : state.collegeReview,
			};

		case GeneralActionTypes.EMPLOYEE_DETAILS_VERIFY_CHENGED:
			return {
				...state,
				employeeIdDetailsVerified: action.payload,
				employeeIdReview: action.payload === 1 ? '' : state.employeeIdReview,
			};

		case GeneralActionTypes.PAYSLIP_DETAILS_VERIFY_CHANGED:
			return {
				...state,
				payslipDetailsVerified: action.payload,
				paySlipReview: action.payload === 1 ? '' : state.paySlipReview,
			};

		case GeneralActionTypes.PANCARD_DETAILS_VERIFY_CHENGED:
			return {
				...state,
				pancardDetailsVerified: action.payload,
				panCardReview: action.payload === 1 ? '' : state.panCardReview,
			};

		case GeneralActionTypes.DRIVINGLICENCE_VERIFY_CHANGED:
			return {
				...state,
				drirvingLicenceDetailsVerified: action.payload,
				dirvingLicenceReview: action.payload === 1 ? '' : state.dirvingLicenceReview,
			};

		case GeneralActionTypes.VOTERID_DETAILS_VERIFY_CHENGED:
			return {
				...state,
				voterIdDetailsVerified: action.payload,
				voterIDCardReview: action.payload === 1 ? '' : state.voterIDCardReview,
			};

		case GeneralActionTypes.PASSPORT_DETAILS_VERIFY_CHANGED:
			return {
				...state,
				passportDetailsVerified: action.payload,
				passportReview: action.payload === 1 ? '' : state.passportReview,
			};

		case GeneralActionTypes.PHOTO_VIDEO_VERIFY_CHENGED:
			return {
				...state,
				photoVideoDetailsVerified: action.payload,
				photosAndVideoReview: action.payload === 1 ? '' : state.photosAndVideoReview,
			};

		case GeneralActionTypes.BANK_DETAILS_VERIFY_CHANGED:
			return {
				...state,
				bankDetailDetailsVerified: action.payload,
				bankDetailsReview: action.payload === 1 ? '' : state.bankDetailsReview,
			};

		case GeneralActionTypes.JOB_DETAILS_CHANGED:
			return {
				...state,
				jobDetails: action.payload,
			};

		/** ************ REVIEW CHANGED DETAILS ************ */
		case GeneralActionTypes.ALL_DOC_MATCH_REVIEW_CHANGED:
			return {
				...state,
				allDocumentMatchedReview: action.payload,
			};

		case GeneralActionTypes.PHONE_CALL_REVIEW_CHANGED:
			return {
				...state,
				phoneCallReview: action.payload,
			};

		case GeneralActionTypes.BASIC_REVIEW_CHANGED:
			return {
				...state,
				basicDetailsReview: action.payload,
			};

		case GeneralActionTypes.AADHAR_REVIEW_CHANGED:
			return {
				...state,
				aadharReview: action.payload,
			};

		case GeneralActionTypes.PAN_REVIEW_CHANGED:
			return {
				...state,
				panCardReview: action.payload,
			};

		case GeneralActionTypes.COLLEGE_REVIEW_CHANGED:
			return {
				...state,
				collegeReview: action.payload,
			};

		case GeneralActionTypes.EMPLOYEE_ID_REVIEW_CHANGED:
			return {
				...state,
				employeeIdReview: action.payload,
			};

		case GeneralActionTypes.PAYSLIP_REVIEW_CHANGED:
			return {
				...state,
				paySlipReview: action.payload,
			};

		case GeneralActionTypes.DRIVING_LICENCE_REVIEW_CHANGED:
			return {
				...state,
				dirvingLicenceReview: action.payload,
			};

		case GeneralActionTypes.PASSPORT_REVIEW_CHANGED:
			return {
				...state,
				passportReview: action.payload,
			};

		case GeneralActionTypes.VOTER_ID_REVIEW_CHANGED:
			return {
				...state,
				voterIDCardReview: action.payload,
			};

		case GeneralActionTypes.PHOTO_VIDEO_REVIEW_CHANGED:
			return {
				...state,
				photosAndVideoReview: action.payload,
			};

		case GeneralActionTypes.BANK_REVIEW_CHANGED:
			return {
				...state,
				bankDetailsReview: action.payload,
			};
		default:
			return state;
	}
};

export default generalReducer;
